import React, { useState } from 'react';
import { dispatchOpenVariantSelectorDropdown } from '../../../sections/header/Cart/components/CartImpulseBuy/utils';
import { addVariant } from '../../../utils/cart';
import { QuickAddPanelTypes } from './QuickAddPanel';
import { hasHiddenInventoryTag } from 'src/scripts/utils/plp-pdp-shared';
import { getIdFromShopifyGraphQLId } from 'src/scripts/utils/shopify';
import { checkIfItemCanBeSoldOut } from 'src/scripts/utils/helpers';

const QuickAddMobile = ({
  extendedData,
  price,
  compareAtPrice,
  ga4options,
  ATBtype,
  purchaseLimitTagData,
  quickFitSizeSelectorText,
  shouldShowATCmodal = true,
}: QuickAddPanelTypes) => {
  const [feedbackCopy, setFeedbackCopy] = useState('');
  // Remember all sold out products after checking the inventory
  const [soldOutHandles, setAsSoldOut] = useState<string[]>([]);

  if (!extendedData.productByHandle) return null;
  const { tags, variants, id, handle, productType } = extendedData.productByHandle;

  const areAllSizesSoldOut = checkIfItemCanBeSoldOut(tags)
    ? extendedData.productByHandle.variants.edges.every((edge) => !edge.node.availableForSale)
    : false;
  const shouldHideInventory = hasHiddenInventoryTag(tags);
  if (areAllSizesSoldOut || shouldHideInventory) return null; // Don't show if all sizes are sold out in the selected color

  const sizesData = variants.edges.map((edge) => {
    return {
      isSizeAvailable: edge.node.availableForSale,
      quantityAvailable: edge.node.quantityAvailable,
      value: edge.node.selectedOptions.find((item) => item.name === 'Size')?.value,
      variantId: getIdFromShopifyGraphQLId(edge.node.id),
      sku: edge.node.sku,
    };
  });

  const variantPricesData = {
    id: Number(sizesData[0]?.variantId),
    price,
    displayPrice: compareAtPrice,
    tags,
    productId: Number(getIdFromShopifyGraphQLId(id)),
  };

  const isOneSizeProduct = sizesData?.length === 1;

  const openSizeDrawer = () => {
    if (isOneSizeProduct) {
      if (sizesData[0]?.isSizeAvailable && sizesData[0]?.variantId) {
        setFeedbackCopy('Added!');
        addVariant(
          sizesData[0].variantId,
          variantPricesData,
          {
            shouldShowATCmodal: true,
            ATBtype,
          },
          ga4options
        );
        setTimeout(() => {
          setFeedbackCopy('');
        }, 1500);
      } else {
        setAsSoldOut([...soldOutHandles, handle]);
      }
    } else {
      setFeedbackCopy('Adding...'); // not added until variant is selected
      dispatchOpenVariantSelectorDropdown({
        sizesData,
        productType,
        mountNodePosition: 0,
        variantPricesData,
        ga4options,
        purchaseLimitTagData,
        quickFitSizeSelectorText,
        ATBtype,
        shouldShowATCmodal,
      });
      setTimeout(() => {
        setFeedbackCopy('');
      }, 1500);
    }
  };

  return (
    <div className={`quick-add`}>
      {feedbackCopy || soldOutHandles.includes(handle) ? (
        <div className="adding-feedback">
          <span>{feedbackCopy || 'Sold Out Online'}</span>
        </div>
      ) : (
        <React.Fragment>
          <div className="quick-add-button-container" onClick={openSizeDrawer}>
            <span>
              <span className="alo-quick-add-icon"></span>
            </span>
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default QuickAddMobile;
